<h2>История промокодов</h2>
<div class="container promo-codes-history-container">
  <!-- ФИЛЬТРЫ -->
  <form class="promo-codes-history-form" [formGroup]="filterForm">
    <mat-form-field class="form-field" appearance="outline">
      <mat-label>ID промокода</mat-label>
      <input
        matInput
        type="number"
        formControlName="codeId"
        placeholder="code_id"
      />
    </mat-form-field>

    <mat-form-field class="form-field" appearance="outline">
      <mat-label>Статус</mat-label>
      <mat-select formControlName="activated">
        <mat-option [value]="null">Все</mat-option>
        <mat-option [value]="true">Активирован</mat-option>
        <mat-option [value]="false">Не активирован</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="form-field" appearance="outline">
      <mat-label>Активирован с</mat-label>
      <input
        matInput
        [matDatepicker]="dpFrom"
        formControlName="minActivatedAt"
      />
      <mat-datepicker-toggle matSuffix [for]="dpFrom"></mat-datepicker-toggle>
      <mat-datepicker #dpFrom></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="form-field" appearance="outline">
      <mat-label>Активирован по</mat-label>
      <input matInput [matDatepicker]="dpTo" formControlName="maxActivatedAt" />
      <mat-datepicker-toggle matSuffix [for]="dpTo"></mat-datepicker-toggle>
      <mat-datepicker #dpTo></mat-datepicker>
    </mat-form-field>
  </form>

  <!-- ТАБЛИЦА -->
  <div class="promo-codes-history-table-container">
    <div class="table-wrapper table-density">
      <div class="table-loading" *ngIf="logSource.isLoading$ | async">
        <mat-spinner diameter="20" style="margin: 0 auto"></mat-spinner>
      </div>

      <table
        mat-table
        [dataSource]="logSource"
        class="table promo-codes-history-table"
      >
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="code_id">
          <th mat-header-cell *matHeaderCellDef>Code ID</th>
          <td mat-cell *matCellDef="let element">
            <a
              *ngIf="element.code_id != null; else noCodeId"
              class="promo-link"
              (click)="openPromoInfo(element.code_id)"
              >{{ element.code_id }}</a
            >
            <ng-template #noCodeId>-</ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="timestamp_used">
          <th mat-header-cell *matHeaderCellDef>Введён</th>
          <td mat-cell *matCellDef="let element">
            {{
              getTimestampUsedUtc(element.timestamp_used)
                | date: "dd.MM.yy HH:mm:ss"
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="chain">
          <th mat-header-cell *matHeaderCellDef>Цепочка</th>
          <td mat-cell *matCellDef="let element">
            {{ getChainState(element)?.campaign?.title || "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="chain_cycle">
          <th mat-header-cell *matHeaderCellDef>Цикл</th>
          <td mat-cell *matCellDef="let element">
            {{ getChainCycle(element) ?? '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="chain_step">
          <th mat-header-cell *matHeaderCellDef>Шаг</th>
          <td mat-cell *matCellDef="let element">
            {{ getChainStep(element) ?? '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="activated">
          <th mat-header-cell *matHeaderCellDef>Активирован</th>
          <td mat-cell *matCellDef="let element">
            {{ element.activated ? "Да" : "Нет" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="timestamp_activated">
          <th mat-header-cell *matHeaderCellDef>Активирован в</th>
          <td mat-cell *matCellDef="let element">
            {{
              element.timestamp_activated
                ? (element.timestamp_activated
                  | date: "dd.MM.yy HH:mm:ss")
                : "-"
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="closed_at">
          <th mat-header-cell *matHeaderCellDef>Отменен</th>
          <td mat-cell *matCellDef="let element">
            {{
              element.closed_at
                ? (element.closed_at | date: "dd.MM.yy HH:mm:ss")
                : "-"
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="deposit_sum">
          <th mat-header-cell *matHeaderCellDef>Депозит</th>
          <td mat-cell *matCellDef="let element">
            {{
              element.deposit_sum != null
                ? (element.deposit_sum / 100 | currency: "USD")
                : "-"
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="reward_value">
          <th mat-header-cell *matHeaderCellDef>Стоимость наград</th>
          <td mat-cell *matCellDef="let element">
            {{
              element.reward_value != null
                ? (element.reward_value / 100 | currency: "USD")
                : "-"
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="payback_amount">
          <th mat-header-cell *matHeaderCellDef>Отыгрыш</th>
          <td mat-cell *matCellDef="let element">
            {{
              element.payback_amount != null
                ? (element.payback_amount / 100 | currency: "USD")
                : "-"
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="transaction_id">
          <th mat-header-cell *matHeaderCellDef>Транзакция</th>
          <td mat-cell *matCellDef="let element">
            {{ element.transaction_id ?? '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="next_promo_id">
          <th mat-header-cell *matHeaderCellDef>Next promo</th>
          <td mat-cell *matCellDef="let element">
            <a
              *ngIf="element.next_promo_id != null; else noNextPromo"
              class="promo-link"
              (click)="openPromoInfo(element.next_promo_id)"
              >{{ element.next_promo_id }}</a
            >
            <ng-template #noNextPromo>-</ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Действия</th>
          <td mat-cell *matCellDef="let element">
            <button
              *ngIf="canManuallyActivate(element)"
              mat-raised-button
              color="primary"
              type="button"
              [disabled]="activatingLogId !== null"
              (click)="activatePromoCode(element)"
            >
              {{
                activatingLogId === element.id
                  ? "Зачисление..."
                  : "Засчитать промокод"
              }}
            </button>
          </td>
        </ng-container>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="columns.length">Нет записей</td>
        </tr>
        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columns"></tr>
      </table>
    </div>

    <mat-paginator
      [length]="logSource.totalCount"
      [pageSizeOptions]="[10, 50, 250, 500]"
    >
    </mat-paginator>
  </div>

  <section
    class="chain-progress"
    *ngIf="
      (logSource.supportsChainHistory$ | async) &&
      (logSource.chainStates$ | async) as chainStates
    "
  >
    <mat-accordion *ngIf="chainStates.length">
      <mat-expansion-panel class="chain-section-panel">
        <mat-expansion-panel-header
          collapsedHeight="52px"
          expandedHeight="52px"
        >
          <mat-panel-title class="chain-section-title">
            Цепочки промокодов
          </mat-panel-title>
          <mat-panel-description class="chain-count">
            {{ chainStates.length }}
            {{ getChainCountLabel(chainStates.length) }}
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-accordion class="chain-list" multi>
          <mat-expansion-panel
            *ngFor="let state of chainStates; trackBy: trackByChainState"
            class="chain-card"
          >
            <mat-expansion-panel-header
              collapsedHeight="48px"
              expandedHeight="48px"
            >
              <mat-panel-title class="chain-card-title">
                <strong class="chain-title">{{ state.campaign.title }}</strong>
                <span class="chain-id">ID {{ state.campaign.id }}</span>
              </mat-panel-title>
              <mat-panel-description class="chain-state">
                {{ getChainStatus(state) }} · цикл {{ state.cycleNo }} · шаг
                {{ state.currentStep }}/{{ state.campaign.chainSteps.length }}
              </mat-panel-description>
            </mat-expansion-panel-header>

            <ng-template matExpansionPanelContent>
              <div class="chain-dates">
                <span
                  >Начало шага:
                  {{ state.stepStartedAt | date: "dd.MM.yy HH:mm" }}</span
                >
                <span *ngIf="state.status === 'active'"
                  >Дедлайн: {{ state.deadlineAt | date: "dd.MM.yy HH:mm" }}</span
                >
                <span *ngIf="state.completedAt"
                  >Завершена:
                  {{ state.completedAt | date: "dd.MM.yy HH:mm" }}</span
                >
              </div>
              <div class="chain-steps">
                <button
                  type="button"
                  *ngFor="let step of getOrderedSteps(state)"
                  class="chain-step"
                  [class.chain-step-completed]="
                    isCompletedStep(state, step.step)
                  "
                  [class.chain-step-current]="
                    state.status === 'active' && step.step === state.currentStep
                  "
                  [disabled]="step.promoCode?.id == null"
                  (click)="openPromoInfo(step.promoCode?.id ?? null)"
                >
                  {{ step.step }}.
                  {{ step.promoCode?.code || "ID " + step.promoCode?.id }}
                </button>
              </div>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-expansion-panel>
    </mat-accordion>
  </section>
</div>
